import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowContainer: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        width: "100%"
    },
    scrollContent: {
        justifyContent: "center",
        alignItems: "center"
    },
    previewContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 120
    },
    descText: {
        marginBottom: 20
    },
    contentContainer: {
        maxWidth: 850,
        width: "100%"
    },
    container: {
        flex: 1
    }
});
export default stylesheet;
